import { isNativeApp } from './platform';
// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://cbdyagjztaqusvqrkusw.supabase.co';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNiZHlhZ2p6dGFxdXN2cXJrdXN3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3NTgwMjksImV4cCI6MjA2NjMzNDAyOX0.eHBlOpGlUWgayOxqR7TaKp5-jBtPp_9WM2DXzgew9Dk';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, isNativeApp() ? {
  auth: { flowType: 'pkce', detectSessionInUrl: false },
} : undefined);

// ✅ Haal de actieve groep op van de gebruiker
export const getCurrentUserGroup = async (userId) => {
  const { data, error } = await supabase
    .from('group_users')
    .select('group_id, role, groups (name, owner_id)')
    .eq('user_id', userId)
    .single();

  if (error || !data) {
    console.error('Fout bij ophalen van groep:', error);
    return null;
  }

  return {
    id: data.group_id,
    name: data.groups.name,
    owner_id: data.groups.owner_id,
    role: data.role
  };
};

// ✅ Haal transacties op (optioneel per groep)
export const fetchTransactions = async (groupId = null) => {
  let query = supabase
    .from('transactions')
    .select('*')
    .order('timestamp', { ascending: false });

  if (groupId) {
    query = query.eq('group_id', groupId);
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching transactions:', error);
    return [];
  }

  return data;
};

// ✅ Voeg nieuwe transactie toe
export const insertTransaction = async (transaction) => {
  const { error } = await supabase
    .from('transactions')
    .insert(transaction);

  if (error) {
    console.error('Error inserting transaction:', error);
    return false;
  }

  return true;
};

// ✅ Haal alle gebruikers binnen een groep op, inclusief email
export const fetchGroupUsers = async (groupId) => {
  const { data, error } = await supabase
    .from('group_users')
    .select('user_id, users(email)')
    .eq('group_id', groupId);

  if (error) {
    console.error('Fout bij ophalen gebruikers van groep:', error);
    return [];
  }

  return data;
};
